import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorGithubButton = customizeCraftJsComponent(EditorButton, {
	name: 'Github Button',
	props: {
		children: '',
		startIcon: 'github',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'github',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
